import { View } from '@neos/app'
import { OpenModeType, PopupPosition } from '@neos/shared'

export const views: View[] = [
  {
    name: 'TmsAscOrderTrackingOperatingEventUI',
    openMode: OpenModeType.newFrame,
    popupPosition: PopupPosition.center,
    component: () => import('./views/TmsAscOrderTrackingOperatingEventUI/TmsAscOrderTrackingOperatingEventUI.vue')
  },
  {
    name: 'TmsAscOrderTrackingUI',
    openMode: OpenModeType.newFrame,
    popupPosition: PopupPosition.center,
    component: () => import('./views/TmsAscOrderTrackingUI/TmsAscOrderTrackingUI.vue')
  },
]